import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationData {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  displayStart: number;
  displayEnd: number;
  actualResults: number;
}

interface PaginationProps {
  pagination: PaginationData;
  currentPage: number;
  onPageChange: (page: number) => void;
  showInfo?: boolean;
  className?: string;
  loading?: boolean;
}

export function Pagination({ 
  pagination, 
  currentPage, 
  onPageChange, 
  showInfo = true,
  className = "",
  loading = false
}: PaginationProps) {
  if (!pagination || pagination.totalPages <= 1) {
    return null;
  }

  return (
    <div className={`flex items-center justify-between p-4 border-t border-gray-200 ${className}`}>
      {/* Pagination Info */}
      {showInfo && (
        <span className="text-sm text-gray-700">
          Page {currentPage + 1} of {pagination.totalPages} ({pagination.total} total records)
        </span>
      )}

      {/* Pagination Controls */}
      <div className="space-x-2 flex items-center">
        <Button 
          onClick={() => onPageChange(currentPage - 1)} 
          disabled={!pagination.hasPrevPage || loading} 
          variant="outline" 
          size="sm"
        >
          <ChevronLeft className="h-4 w-4 mr-1" />
          Previous
        </Button>
        <Button 
          onClick={() => onPageChange(currentPage + 1)} 
          disabled={!pagination.hasNextPage || loading} 
          variant="outline" 
          size="sm"
        >
          Next
          <ChevronRight className="h-4 w-4 ml-1" />
        </Button>
      </div>
    </div>
  );
} 